import {
  Color,
  Header,
  Paragraph
} from '@eggplant/pattern-library'
import type { CSSProperties } from 'react'

const wrapperStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  rowGap: '24px',
  textAlign: 'center'
}

const Inaccessible = () =>
  <div style={wrapperStyle}>
    <Header rank={2}>
      Upgrade to access content
    </Header>
    <Paragraph>
      <Color variant='theme-description-text'>
        We are sorry, but you do not have the license to access this feature.
        <br />
        Please contact our customer support to learn more about our licenses and upgrades.
      </Color>
    </Paragraph>
  </div>

export default Inaccessible
